<div class="login-inside-container" id="div_login-inside-container_aa04fb04">
  <h1 aria-label="WELCOME" title="WELCOME" id="h1_eaa7db6a">WELCOME</h1>
  <form [formGroup]="frmLogin" id="form_d20316c6">
    <label
      aria-label="Please enter your password"
      title="Please enter your password"
      id="label_d8bd75e5"
      >Please enter your password.</label
    >
    <span class="p-float-label" id="span_p-float-label_16053172">
      <input
        id="password"
        type="password"
        (keydown.enter)="login()"
        pInputText=""
        name="password"
        formControlName="password"
      />
      <label for="password" id="label_17013570">Password</label>
    </span>
    <small class="p-error block" *ngIf="error" id="small_p-error_a4f91666">{{
      errorMessage
    }}</small>
    <div class="btn-panel" id="div_btn-panel_509bd337">
      <button
        class="back-button"
        type="button"
        (click)="back()"
        id="button_back-button_5caba7bb"
      >
        <i class="pi pi-angle-left" id="i_pi_5ecbebc7"></i>
      </button>
      <button
        class="next-button"
        type="button"
        (click)="login()"
        [disabled]="!frmLogin.valid"
        id="button_next-button_c857edf8"
      >
        NEXT
      </button>
    </div>
    <div class="bottom-pnl" id="div_bottom-pnl_35ec8778">
      <a
        aria-label="Forgot Password"
        title="Forgot Password"
        (click)="forgotPassword()"
        id="a_e2bcf619"
        >Forgot Password?</a
      >
    </div>
  </form>
</div>
<div
  class="progress-spinner"
  *ngIf="loading"
  id="div_progress-spinner_aa263a83"
>
  <p-progressSpinner
    styleClass="custom-spinner"
    id="p-progressSpinner_e6fb02bd"
  ></p-progressSpinner>
</div>
